import React from 'react';
import { Box } from '@mui/material';
import HeroSection from '../components/HeroSection';
import FeaturedIn from '../components/FeaturedIn';
import AboutSection from '../components/AboutSection';
import SpeakingEngagements from '../components/SpeakingEngagements';
import SpeakingEvents from '../components/SpeakingEvents';
import WritingSection from '../components/WritingSection';
import OrganizationsILove from '../components/OrganizationsILove';
import MentorshipSection from '../components/MentorshipSection';

const HomePage: React.FC = () => {
  return (
    <Box>
      <Box id="home">
        <HeroSection />
      </Box>
      <Box id="featured">
        <FeaturedIn />
      </Box>
      <Box id="about">
        <AboutSection />
      </Box>
      <Box id="speaking-engagements">
        <SpeakingEngagements />
      </Box>
      <Box id="speaking-events">
        <SpeakingEvents />
      </Box>
      <Box id="writing">
        <WritingSection />
      </Box>
      <Box id="organizations">
        <OrganizationsILove />
      </Box>
      <Box id="mentorship">
        <MentorshipSection />
      </Box>
    </Box>
  );
};

export default HomePage;